import { render } from "./StockRangeFactorItem.vue?vue&type=template&id=2c608502&scoped=true&ts=true"
import script from "./StockRangeFactorItem.vue?vue&type=script&lang=ts"
export * from "./StockRangeFactorItem.vue?vue&type=script&lang=ts"

import "./StockRangeFactorItem.vue?vue&type=style&index=0&id=2c608502&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c608502"]])

export default __exports__